import React from 'react';
import { node, bool, string } from 'prop-types';
import classNames from 'classnames/bind';

import styles from './TripletRow.scss';

const cx = classNames.bind(styles);

export default function TripletRow({ title, withBorder, children }) {
  const childrenArray = React.Children.toArray(children);
  const tripletRowClass = cx({
    main: true,
    withBorder,
  });
  return (
    <div className={tripletRowClass}>
      {title &&
        <h3 className={styles.title}>
          {title}
        </h3>}
      <dl className={styles.rowItemsContainer}>
        {childrenArray.map(child => child)}
      </dl>
    </div>
  );
}

TripletRow.propTypes = {
  title: string,
  children: node.isRequired,
  withBorder: bool,
};

TripletRow.defaultProps = {
  title: null,
  withBorder: false,
};



// WEBPACK FOOTER //
// ./src/components/DataPanel/TripletRow/index.js